<template>
  <div>
    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 sticky">
            <div class="card card-benefit">
              <div class="card-benefit-header">
                {{ myBenefit.product_name }}
              </div>
              <div class="card-benefit-body">
                            <span class="text-description">
                                Periode : {{ isDate(myBenefit.policy_date) }} - {{ isDate(myBenefit.policy_end_date) }}
                            </span>
              </div>
            </div>

            <template v-if="!(benefitDetail.is_family && benefitDetail.benefit_year_limit_family > 0)">

              <div class="card card-benefit">
                <div class="card-benefit-header">Limit Tahunan</div>
                <div class="card-benefit-body">
                  <span class="text-description">Rp. {{ number(myBenefit.benefit_year_limit) }}</span>
                </div>
              </div>

              <div class="card card-benefit">
                <div class="card-benefit-header">Limit Digunakan</div>
                <div class="card-benefit-body">
                  <span class="text-description">Rp. {{ number(benefitDetail.limit_usage) }}</span>
                </div>
              </div>

              <div class="card card-benefit">
                <div class="card-benefit-header">Limit Tersisa</div>
                <div class="card-benefit-body">
                  <span class="text-description">Rp. {{ number(myBenefit.benefit_year_limit - benefitDetail.limit_usage) }}</span>
                </div>
              </div>

            </template>

            <template v-if="benefitDetail.is_family && benefitDetail.benefit_year_limit_family > 0">
              <div class="card card-benefit" >
                <div class="card-benefit-header">
                  Limit Keluarga Tahunan
                </div>
                <div class="card-benefit-body">
                  <span class="text-description">
                      Rp. {{ number(benefitDetail.benefit_year_limit_family) }}
                  </span>
                </div>
              </div>

              <div class="card card-benefit">
                <div class="card-benefit-header">
                  Limit Keluarga Digunakan
                </div>
                <div class="card-benefit-body">
                  <span class="text-description">
                      Rp. {{ number(benefitDetail.family_limit_usage) }}
                  </span>
                </div>
              </div>

              <div class="card card-benefit">
                <div class="card-benefit-header">
                  Limit Keluarga Tersisa
                </div>
                <div class="card-benefit-body">
                  <span class="text-description">
                      Rp. {{ number(benefitDetail.benefit_year_limit_family - benefitDetail.family_limit_usage) }}
                  </span>
                </div>
              </div>
            </template>

            <div class="card card-benefit">
              <div class="card-benefit-header">
                Nama Peserta
              </div>
              <div class="card-benefit-body">
                            <span class="text-description">
                                {{ myBenefit.nama_tertanggung }}
                            </span>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3" v-for="benefit in benefitDetail.benefit" :key="benefit.name">
              <div class="benefit-other text-color-blue text-uppercase">
                <div class="text-description font-weight-bolder">
                  {{ benefit.name }}
                </div>
                <span class="text-description">
                                {{ benefit.benefit_limit }}
                            </span>
                <span class="text-description" v-if="benefit.external_benefit_note != null">
                                * {{ benefit.external_benefit_note }}
                            </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment"

export default {
  props: {
    myBenefit: Object,
    benefitDetail: Object
  },
  methods: {
    isDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    number(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}

</script>

<style>

</style>